<template>
  <v-dialog
    v-model="partnerDialog"
    fullscreen
    hide-overlay
    transition="dialog-bottom-transition"
    lazy
  >
    <v-card>
      <v-toolbar dark color="#7C3DFF">
        <v-toolbar-title class="m-0 white--text"
          >Dados do Parceiro</v-toolbar-title
        >
        <v-spacer></v-spacer>
        <v-toolbar-items>
          <v-btn icon dark flat @click="setPartnerDialog(false)">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar-items>
      </v-toolbar>

      <v-container fluid>
        <v-form ref="form" v-model="valid" lazy-validation>
          <v-card>
            <v-card-title>
              <span class="headline"
                >{{ type === "new" ? "Adicionar" : "Editar" }} Parceiro</span
              >
            </v-card-title>

            <v-card-text>
              <v-container grid-list-md>
                <v-layout wrap>
                  <v-flex xs12 sm4 md4>
                    <v-text-field
                      label="Nome"
                      v-model="name"
                      :rules="[
                        (v) => !!v || 'Por favor, informe o nome do parceiro!',
                      ]"
                      required
                    />
                  </v-flex>
                  <v-flex xs12 sm4 md4>
                    <v-text-field
                      label="ID"
                      v-model="id"
                      :rules="[
                        (v) => !!v || 'Por favor, informe o ID do parceiro!',
                      ]"
                      required
                      :disabled="type === 'edit'"
                    />
                  </v-flex>
                  <v-flex xs12 sm4 md4>
                    <v-text-field label="URL" v-model="url" />
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card-text>

            <v-card-actions>
              <v-spacer />
              <v-btn
                flat
                color="success"
                @click="validate()"
                :loading="loading"
                :disabled="buttonDisable()"
              >
                Salvar
              </v-btn>
            </v-card-actions>

            <recipients-list
              v-if="type === 'edit'"
              :partnerId="partnerId"
              :accounts="bankAccounts"
            />
          </v-card>
        </v-form>
      </v-container>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions, mapGetters, mapMutations, mapState } from "vuex";
import RecipientsList from "./RecipientsList.vue";

export default {
  components: { RecipientsList },

  props: {
    type: {
      type: String,
      default: "new",
    },
    partnerId: {
      type: String,
      default: null,
    },
  },

  data: () => ({
    rules: [],
    loading: false,
    valid: false,
    search: "",
    name: "",
    id: "",
    url: "",
  }),

  computed: {
    ...mapState("configuration", ["partnerDialog"]),
    ...mapGetters("configuration", ["partnerById"]),

    partner() {
      return this.partnerId ? this.partnerById(this.partnerId) : {};
    },
    bankAccounts() {
      return this.partner ? this.partner.bankAccounts : [];
    },
  },

  methods: {
    ...mapActions("configuration", ["addPartner", "updatePartner"]),
    ...mapMutations("configuration", ["setPartnerDialog"]),

    buttonDisable() {
      return (
        !this.valid ||
        this.name.trim() === "" ||
        this.id.trim() === "" ||
        this.loading
      );
    },

    async validate() {
      if (this.$refs.form.validate()) {
        this.loading = true;
        const data = {
          name: this.name,
          id: this.id,
          url: this.url,
        };
        if (this.type === "new") {
          await this.addPartner(data);
        } else if (this.type === "edit") {
          await this.updatePartner(data);
        }
        this.loading = false;
      }
      this.setPartnerDialog(false);
    },
  },

  mounted() {
    this.loading = true;
    this.name = this.partner.name ?? "";
    this.id = this.partner.id ?? "";
    this.url = this.partner.url ?? "";
    this.loading = false;
  },
};
</script>
